import { faker } from "@faker-js/faker";

import { fakeBaseUserType } from "@/__mocks__/mockBaseTypes";
import { merge } from "@/__mocks__/mockHelpers";

const fakeModifiedBy = (overrides?: DeepPartial<ModifiedBy>): ModifiedBy => {
  const modifiedBy: ModifiedBy = {
    chosenName: faker.person.firstName(),
    externalId: faker.string.uuid(),
    firstName: faker.person.firstName(),
    lastName: faker.person.lastName(),
    providerType: faker.word.sample(),
    type: fakeBaseUserType(),
  };
  return merge(modifiedBy, overrides);
};

const fakeObservation = (overrides?: DeepPartial<Observation>): Observation => {
  const observation: Observation = {
    createdAt: faker.date.anytime().toISOString(),
    createdBy: faker.string.uuid(),
    externalId: faker.string.uuid(),
    lastUpdatedAt: faker.date.anytime().toISOString(),
    observationDatetime: faker.date.anytime().toISOString(),
    patientExternalId: faker.string.uuid(),
    source: faker.word.sample(),
    status: faker.word.sample(),
    type: faker.word.sample(),
    unit: faker.science.unit().name,
    updatedByUserId: faker.string.uuid(),
    value: faker.number.float({ fractionDigits: 4, max: 999.9999, min: 0 }),
  };
  return merge(observation, overrides);
};

const fakePatientObservationData = (
  overrides?: DeepPartial<PatientObservationData>,
): PatientObservationData => {
  const data: PatientObservationData = {
    createdBy: fakeModifiedBy(),
    observation: fakeObservation(),
    updatedBy: fakeModifiedBy(),
  };
  return merge(data, overrides);
};

const fakePatientObservationsResponse = (
  overrides?: DeepPartial<PatientObservationsResponse>,
): PatientObservationsResponse => {
  const count = faker.number.int({ max: 10, min: 1 });
  const response: PatientObservationsResponse = {
    count,
    data: faker.helpers.multiple(() => fakePatientObservationData(), { count }),
    pageNumber: 1,
    pageSize: count,
  };
  return merge(response, overrides);
};

export { fakePatientObservationData, fakePatientObservationsResponse };
